import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { Button, ButtonGroup, FormData } from 'components/misc'
import { form } from 'helpers/decorators'
import { get } from 'lodash'
import styles from './task-logs.styl'
import moment from 'moment'
import { FormattedDate, FormattedTime } from '../../../../components/intl'
import { ImageGallery } from '../../../misc'
import { FormattedPlural, FormattedMessage } from 'react-intl'


const enhance = compose(
    form({
        form: 'taskLogs'
    })
)
class TaskLogs extends Component {
    static propTypes = {
        activity: PropTypes.object.required,
        modal: PropTypes.func.isRequired,
        activities: PropTypes.object.isRequired,
        intl: PropTypes.object.isRequired
    }

    handleDialogClose = () => this.setState({ deleteConfirmDialogOpen: false })

    render() {
        const {
            activity,
            intl
        } = this.props

        const logs = get(activity, 'logs')

        const activityLabel = !get(activity, 'activityCategory.isPublic') ? 'Other activity' : 'Activity'

        const activityIntl = !get(activity, 'activityCategory.isPublic') ? 'label.other_activity' : 'label.activity'

        return (
            <div>

                <h1 className="reset--margin-bottom">{get(activity, 'activityCategory.translatedName')}</h1>
                <br />
                <div className="row">
                    <div className="col-xs-6">
                        <h2>
                            <FormattedMessage
                                id="moduleTitle.activity_detail"
                                defaultMessage="Activity Detail"
                            />
                        </h2>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xs-3">
                        <FormData label="Activity Type" intlKey="label.activity_type">
                            {get(activity, 'activityCategory.parent.translatedName')}
                        </FormData>
                    </div>

                    <div className="col-xs-3">
                        <FormData label={activityLabel} intlKey={activityIntl}>
                            {get(activity, 'activityCategory.translatedName')}
                        </FormData>
                    </div>
                    <div className="col-xs-6">
                        <FormData label="Aim" intlKey="label.aim">
                            {get(activity, 'aim')}
                        </FormData>
                    </div>
                </div>

                <div className="row">

                    <div className="col-xs-6">
                        <h2>
                            <FormattedMessage
                                id="moduleTitle.assessor_detail"
                                defaultMessage="Assessor detail"
                            />
                        </h2>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xs-2">
                        <FormData label="Title" intlKey="label.title">
                            {activity.assessorTitle || '---'}
                        </FormData>
                    </div>
                    <div className="col-xs-2">
                        <FormData label="Name" intlKey="label.name">
                            {activity.assessorName || '---'}
                        </FormData>
                    </div>
                    <div className="col-xs-3">
                        <FormData label="Email" intlKey="label.email">
                            {activity.assessorEmail || '---'}
                        </FormData>
                    </div>
                    <div className="col-xs-2">
                        <FormData label="Phone" intlKey="label.phone">
                            {activity.assessorPhone || '---'}
                        </FormData>
                    </div>
                    <div className="col-xs-3">
                        <FormData label="State" intlKey="label.state">
                            {get(
                                activity,
                                'assessorRegistration.assessorState.translationText',
                            ) ||
                            get(activity, 'assessorRegistration.assessorState.value') ||
                            '---'}
                        </FormData>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xs-6">
                        <h2>
                            <FormattedMessage
                                id="moduleTitle.logs"
                                defaultMessage="Logs"
                            />
                        </h2>
                    </div>
                    <div className="col-xs-6 text--right">
                        <p>
                            {get(activity, 'total')
                                ? `${activity.completed / 3600} / ${activity.total / 3600} h`
                                : ''}
                        </p>
                    </div>
                </div>


                <div className="row">

                    {logs && logs.length > 0 && (
                        <ul className={styles.logs}>
                            {logs.map((log, index) => {
                                const time = moment.duration(log.duration, 'seconds')
                                const hours = Math.floor(time.asHours())
                                const mins = Math.floor(time.asMinutes()) - hours * 60
                                const isDeleted = log && log.deleted === true

                                return (
                                    <li
                                        key={`${log.id}-${index}`}
                                        className={[styles.log, isDeleted && styles.deleted].join(' ')}
                                    >
                                        <div>
                                            <div className={styles.link}>
                                                <div className={styles.header}>
                                                    <div className={styles.time}>
                                                        {log.date && <FormattedDate value={log.date} spaceAfter />}{' '}
                                                        <span className={styles.duration}>
                          {hours}{' '}
                                                            <FormattedPlural
                                                                value={hours}
                                                                one={intl.formatMessage({
                                                                    id: 'logs.hour',
                                                                    defaultMessage: 'hour',
                                                                })}
                                                                other={intl.formatMessage({
                                                                    id: 'logs.hours',
                                                                    defaultMessage: 'hours',
                                                                })}
                                                            />{' '}
                                                            &nbsp;
                                                            {mins}{' '}
                                                            <FormattedPlural
                                                                value={mins}
                                                                one={intl.formatMessage({
                                                                    id: 'logs.minute',
                                                                    defaultMessage: 'minute',
                                                                })}
                                                                other={intl.formatMessage({
                                                                    id: 'logs.minutes',
                                                                    defaultMessage: 'minutes',
                                                                })}
                                                            />
                        </span>
                                                        {isDeleted && (
                                                            <span className={styles.deletedText}>
                            <FormattedMessage defaultMessage="Deleted" id="states.deleted" />
                          </span>
                                                        )}
                                                    </div>
                                                    <div className={styles.created}>
                                                        {log.createdAt && (
                                                            <div>
                                                                <FormattedMessage id="label.created_at"
                                                                                  defaultMessage="Created at" />
                                                                : <FormattedDate timeZone="utc" value={log.createdAt}
                                                                                 spaceAfter />{' '}
                                                                <FormattedTime timeZone="utc" value={log.createdAt} />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className={styles.footer}>
                                                    <p className={styles.description}>{log.description}</p>
                                                </div>
                                            </div>
                                            <ImageGallery urls={log.fileUrls || []} className={styles.image} />
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>
                    )}
                    {logs.length === 0 && <div className={styles.noLogs}> <FormattedMessage id="logs.no_logs" defaultMessage="No logs" /></div>}

                </div>
                <div className="row">
                    <div className="col-xs-8">
                        <ButtonGroup>
                            <Button
                                type="button"
                                secondary
                                onClick={() => this.props.modal(null)}
                                intlKey="button.close"
                            >
                                Close
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>
            </div>
        )
    }
}

export default enhance(TaskLogs)
